/**
 * Menu Toggle Behaviors
 *
 */
function initNavMenu() {
  const mobileNav = document.querySelector('.wp-block-bigbite-mobile-navigation');

  // If there's no nav menu, none of this is necessary.
  if (!mobileNav) {
    return;
  }

  const siteHeader = document.querySelector('.wp-block-bigbite-header');
  const menuToggle = mobileNav.querySelector('.wp-block-bigbite-mobile-navigation__toggle');
  const navMenu = mobileNav.querySelector('.wp-block-bigbite-mobile-navigation__menu');

  /**
   *
   * @param {Element} nav the nav menu to toggle
   * @param {Element} toggle the button to toggle the nav menu
   */
  function toggleMenu(nav, toggle) {
    nav.classList.toggle('is-open');
    if (nav.classList.contains('is-open')) {
      document.documentElement.classList.add('is-mobile-menu-open');
      toggle.setAttribute('aria-expanded', true);
      toggle.setAttribute('aria-label', 'Close Mobile Navigation');
    } else {
      document.documentElement.classList.remove('is-mobile-menu-open');
      toggle.setAttribute('aria-expanded', false);
      toggle.setAttribute('aria-label', 'Open Mobile Navigation');
    }
  }

  menuToggle.addEventListener('click', () => toggleMenu(mobileNav, menuToggle));

  /**
   * Get the offset of an element.
   *
   * @param {Element} el
   * @returns {Object} the offset of the element
   */
  function offset(el) {
    const rect = el.getBoundingClientRect();
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return {
      top: rect.top + scrollTop,
      left: rect.left + scrollLeft,
      bottom: rect.top + scrollTop + el.offsetHeight,
    };
  }

  // move nav menu to bottom of header
  if (siteHeader) {
    if (navMenu) {
      navMenu.style.top = `${offset(siteHeader).bottom - 1}px`;
      window.addEventListener(
        'resize',
        () => {
          navMenu.style.top = `${offset(siteHeader).bottom - 1}px`;
        },
        true,
      );
    }
  }
}

window.addEventListener('load', () => {
  initNavMenu();
});
